import { ovl, SYSConfig } from "./"
import { SessionUpdate } from "./global/globalapi"
import {
  isMobile,
  isTouch,
  logout,
  stringifyReplacer,
  SYSSeqId,
  T,
} from "./global/globals"
import { DialogModal } from "./library/dialog/dialogapi"
import type { SnackType } from "./library/snack/snack"
import { SnackAdd } from "./library/snackapi"
import { SYSTOTPFields } from "../ovlsyscomponents/systotp01/features/formfields"

export let lastNoServerConnectionMsg: number

export const postRequest = async (
  url,
  data,
  isBlob?: boolean,
  noSnack?: boolean,
  customTimeoutMs?: number,
  authCookieCheck?: boolean
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "POST",
    isBlob,
    noSnack,
    customTimeoutMs,
    false

    //indicatorOptions
  )
}

export const postFormDataRequest = async (
  url,
  data
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "POST",
    false,
    false,
    -1,
    true
    //indicatorOptions
  )
}

//export type AssetDisplayMode = "Table" | "Edit"

// now when used for the fetch stuff we need an extended AssetType
// export const getAssetRequest = async (
//   url,
//   data: AssetRequestParams,
//   isBlob?: boolean,
//   noSnack?: boolean
//   //indicatorOptions?: IndicatorOptions
// ) => {
//   return await ovlFetch(
//     url,
//     data,
//     "GET",
//     isBlob,
//     noSnack,
//     -1,
//     false
//     //indicatorOptions
//   )
// }

export const getRequest = async (
  url,
  data: any,
  isBlob?: boolean,
  noSnack?: boolean
  //indicatorOptions?: IndicatorOptions
) => {
  return await ovlFetch(
    url,
    data,
    "GET",
    isBlob,
    noSnack,
    -1,
    false
    //indicatorOptions
  )
}

let lastAppNoServerConnectionTimestamp = 0
let lastAppReloginTimestamp = 0

export type FetchExceptionType = {
  fetchParams?: { url: string; reqOptions: any }
  headers: any
  data?: any
  status: number
  message: string
  stacktrace?: string
  type: string
}

export function FetchException(message: FetchExceptionType) {
  this.fetchParams = message.fetchParams
  this.headers = message.headers
  this.data = message.data
  this.status = message.status
  this.message = message.message
  this.stacktrace = message.stacktrace
  this.type = message.type
}

export type SYSFetchResult = {
  status: number
  data: any
  headers: any
  message: string
  type: string
  TOTPCanceled?: boolean
}

export type SYSPreconditionRequired = {
  RequestKey: string
  Message: string
  Data: any
  ValidForDays: number
  Type: "TOTPLogin" | "TOTPPwChange"
}

export const ovlFetch = async (
  url,
  data,
  method: string,
  isBlob?: boolean,
  noSnack?: boolean,
  customTimeoutMs?: number,
  isFormData?: boolean,
  isAuthCheck?: boolean
  //indicatorOptions?: IndicatorOptions
): Promise<SYSFetchResult> => {
  let res
  let snackMessage = ""
  let type = ""
  let snackMessageType: SnackType = "Information"
  let reqOptions
  let timer
  let state = ovl.getState()
  let isApiAccess = url.indexOf(state.ovl.apiUrl) > -1
  //let token = state.ovl.session.Token
  try {
    //ovl.getActions().ovl.indicator.SetIndicatorOpen(indicatorOptions)
    // Create request to api service

    reqOptions = {
      method,
      headers: {},
      signal: undefined,
    }

    let headers = {}
    if (method === "POST" && !isFormData) {
      let contentType = "application/json"
      reqOptions.headers["Content-Type"] = contentType
    }
    let user = state.ovl.user
    if (state.ovl.app.clientId) {
      reqOptions.headers["X-Ovl-Client-Id"] = state.ovl.app.clientId
    }
    // if (SYSConfig.fetch.authMode === "token" && user && token) {
    //   reqOptions.headers["itfprt"] = token
    // } else if (SYSConfig.fetch.authMode === "jwtToken" && user && token) {
    //   reqOptions.headers["Authorization"] = "Bearer " + token
    // } else if (SYSConfig.fetch.authMode === "cookie") {
    reqOptions.credentials = "include"
    //}

    if (url.indexOf("ovlnocache") > -1) {
      reqOptions["Cache"] = "no-cache"
      headers["pragma"] = "no-cache"
    }

    if (isFormData) {
      reqOptions["body"] = data
    } else if (method === "POST") {
      reqOptions["body"] = JSON.stringify(data, stringifyReplacer)
    } else if (data) {
      if (typeof data !== "object") {
        throw new Error(
          "ovl fetch: Get Request Param need to be an flat Object"
        )
      }
      url = GetUrlWithParams(url, data)
    }

    // forced timeout only in offline mode...timeouts are normally handled by the browser itself
    // but we need to rely on a timeout in offline mode which works the same across browsers, hence the forced timeout
    if (SYSConfig.offline.enabled) {
      let timeOutMs = SYSConfig.fetch.timeout
      if (customTimeoutMs && customTimeoutMs > -1) {
        timeOutMs = customTimeoutMs
      }
      if (timeOutMs && timeOutMs > 0) {
        const controller = new AbortController()
        const { signal } = controller

        timer = setTimeout(() => {
          controller.abort()
        }, timeOutMs)

        reqOptions.signal = signal
      }
    }
    const req = await fetch(url, reqOptions)
    if (SYSConfig.offline.enabled) {
      clearTimeout(timer)
    }
    if (
      isApiAccess &&
      (!SYSConfig.offline.enabled || reqOptions.method === "POST")
    ) {
      ovl.getState().ovl.app.offline.api = false
    }

    // lets check if backend requests totp
    if (req.status === 428) {
      var pcond: SYSPreconditionRequired = await req.json()

      if (pcond.Type.startsWith("TOTP")) {
        var instance = SYSSeqId()
        let fields = JSON.parse(JSON.stringify(SYSTOTPFields))

        let data = {
          Language: pcond.Data?.Language,
          Type: pcond.Type,
          Message: pcond.Message,
          RequestKey: pcond.RequestKey,
          ValidForDays: pcond.ValidForDays,
        }
        if (pcond.Data) {
          data["SetupManualCode"] = pcond.Data.SetupManualCode
          data["SetupQrCodeImageUrl"] = pcond.Data.SetupQrCodeImageUrl
        }

        return await DialogModal("SYSTOTP", {
          data,
          instance,
          formsHandling: [
            {
              isConnectedToDialog: true,
              formType: "SYSTOTP",
              formId: instance,
              removeFormStateWhenClose: true,
              creation: {
                autoInitFormFields: fields,
                initialFocusFieldKey: "TOTPDigit1",
              },
            },
          ],
        })
      }
    }

    // with fetch we will have the repsonse status here on req object
    if (req.ok) {
      // ok all good
      // whenever there is a token change. save it to localStorage
      // let itfprttoken = req.headers.get("itfprttoken")
      // if (itfprttoken !== null) {
      //   await SessionUpdate("Token", itfprttoken)
      // }

      let itfprtsession = req.headers.get("itfprtsession")
      if (itfprtsession !== null) {
        let sessionObj = JSON.parse(itfprtsession)

        Object.keys(sessionObj).forEach((k) => {
          //@ts-ignore
          SessionUpdate(k, sessionObj[k])
        })
      }
      if (isBlob) {
        res = await req.blob()
      } else {
        const contentType = req.headers.get("content-type")

        if (contentType && contentType.indexOf("application/json") !== -1) {
          res = await req.json()
        }
      }
      let res0 = { res }
      //if (SYSConfig.fetch.useCompressed === true) {
      checkAllArrayPropertiesForCompressedAndUncompress(res0)
      //}
      snackMessageType = "Success"
      return {
        headers: req.headers,
        data: res0.res,
        status: req.status,
        message: "",
        type: "",
      }
    } else {
      snackMessageType = "Error"
      snackMessage = ""
      if (req.status === 429) {
        // we are hitting ratelimit ourself
        // wait for window
        //SnackAdd("Breathe...")
        // we breathe for 10 secs because we have 10 secs fixed window on backend
        await new Promise((res) => setTimeout(res, 10000))

        return await ovlFetch(
          url,
          data,
          method,
          isBlob,
          noSnack,
          customTimeoutMs,
          isFormData
        )
      } else if (req.status === 401) {
        if (url.endsWith("logout")) {
          location.reload()
        }
        let msg
        try {
          msg = await req.json()
        } catch {}
        // if (msg?.type === "OvlSessionNotFound") {
        //   logout()
        //   return
        // }
        // unauthorised
        snackMessage = ""
        let now = Date.now()
        if (/*token &&*/ now > lastAppReloginTimestamp + 5000 && !isAuthCheck) {
          lastAppReloginTimestamp = now
          SnackAdd(T("SYSLoginPleaseRelogin"))
        }
        await DialogModal("SYSLogin")
        if (isAuthCheck) {
          return
        }
        return await ovlFetch(
          url,
          data,
          method,
          isBlob,
          noSnack,
          customTimeoutMs,
          isFormData
        )
      } else if (req.status === 413) {
        if (!noSnack) {
          snackMessage = T("SYSUploadTooBig")
        }
        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: 413,
          message: T("SYSUploadTooBig"),
          type: "",
        })
      } else if (req.status === 404) {
        // well...  go to offline mode. We need it as well here (depends on the webserver...)
        if (isApiAccess) {
          ovl.getState().ovl.app.offline.api = true
        }
        let nfurl = url
        if (data && data.id1) {
          nfurl = data.id1
        }
        if (!SYSConfig.offline.enabled && !noSnack) {
          snackMessage = T("SYSResourceNotFound", [nfurl])
        }
        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: 404,
          message: snackMessage,
          type: "",
        })
      } else if (req.status === 403) {
        snackMessage = T("SYSNotAllowed")
        // we need this snack for sure
        noSnack = false
        // we need to throw the FetchException for the callers logic
        // test usecase BAR ACTActivitiesUserExt Close an activity when in Role Close is not configured
        // but we will already snack out a general not allowed message for all the default usecases (eg. translations form update)
        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: 403,
          message: snackMessage,
          type: "OvlResourceForbidden",
        })
      } else if (req.status === 400) {
        // when having a 400 we may have a returned type property which could be important for ovl (validation)
        let msg = await req.json()
        if (msg) {
          if (msg.type) {
            type = msg.type
          }
          if (msg.message) {
            snackMessage = msg.message
          } else {
            snackMessage = req.statusText
          }
        }

        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: 400,
          message: snackMessage,
          type: type,
        })
      } else if (req.status === 422) {
        let type = ""
        let msg = await req.json()
        if (msg.type) {
          type = msg.type
        }
        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: 422,
          message: msg.errormessage,
          type,
        })
      } else {
        let msg = undefined
        try {
          msg = await req.json()
        } catch {
          // if there is no json result (eg. a 500 error throwed from server)
          // create a generic one
          msg = { message: "Server Error" }
        }
        let type = msg.type
        if (!type) {
          if (msg) {
            if (!msg.message) {
              snackMessage = "Server Error"
            } else {
              snackMessage = msg.message
            }
          }
        }

        throw new FetchException({
          headers: req.headers,
          data: undefined,
          status: req.status,
          message: msg.message,
          stacktrace: msg.stacktrace,
          type: type,
        })
      }
      // init with error
    }
  } catch (err) {
    console.log(err)
    if (err instanceof FetchException) {
      throw err
    }

    // connection error
    // well...  go to offline mode
    if (isApiAccess) {
      ovl.getState().ovl.app.offline.api = true
    }

    let state = ovl.getState()
    // don't display connection error msgs in offline mode and already logged in
    // instead use other indication (blinking offline stuff to signalize we are offline)
    let noServerConnectionMsg = "No Server Connection!"
    if (!SYSConfig.offline.enabled || !state.ovl.app.ready) {
      let now = Date.now()
      if (now > lastAppNoServerConnectionTimestamp + 5000) {
        lastAppNoServerConnectionTimestamp = now
        setTimeout(() => {
          SnackAdd(noServerConnectionMsg, "Warning")
        }, 2000)
      }
    }
    throw new FetchException({
      fetchParams: { url, reqOptions },
      headers: undefined,
      data: undefined,
      status: 449,
      message: noServerConnectionMsg,
      type: "OvlServerOffline",
    })
  } finally {
    //ovl.getActions().ovl.indicator.SetIndicatorClose(indicatorOptions)
    if (timer) {
      clearTimeout(timer)
    }
    if (snackMessage && !type) {
      //@ts-ignore
      if (!noSnack || snackMessageType === "Error") {
        //@ts-ignore
        if (snackMessageType === "Error") {
          console.log("Fetch Error: " + snackMessage)
        }
        if (!noSnack) {
          SnackAdd(snackMessage, snackMessageType)
        }
      }
    }
  }
}

const checkAllArrayPropertiesForCompressedAndUncompress = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        obj[key] = _uncompressAndMassageServerData(obj[key])
        checkAllArrayPropertiesForCompressedAndUncompress(obj[key])
      } else if (typeof obj[key] === "object") {
        checkAllArrayPropertiesForCompressedAndUncompress(obj[key])
      }
    }
  }
}

const _uncompressAndMassageServerData = (serverData: any[]): any[] => {
  if (serverData[1] !== undefined) {
    // there is more than 1 row check if first object.keys from second row is in first row

    // and it needs to be an array of objects
    // and first entriy object value needs to be string
    // if no its the compressed format
    if (
      typeof serverData[0] === "object" &&
      typeof Object.keys(serverData[0])[0] === "string" &&
      serverData[0][Object.keys(serverData[1])[0]] === undefined
    ) {
      // compressed format...
      // create a map with colIndex -> colName
      let colIndexToColName = new Map<string, string>()
      Object.keys(serverData[0]).forEach((key) => {
        colIndexToColName.set(serverData[0][key].toString(), key)
      })

      // remove first row
      serverData.shift()
      let uncompressedData = serverData.map((row) => {
        let newRow = {}
        for (let key of colIndexToColName.keys()) {
          let colVal = row[key]
          if (colVal === undefined) {
            colVal = null
          }
          let colName = colIndexToColName.get(key)
          if (newRow[colName] === undefined) {
            newRow[colName] = colVal
          }
        }
        return newRow
      })
      serverData = uncompressedData
    }
  }
  return serverData
}

export const GetUrlWithParams = (url: string, data: {}): string => {
  // encode data as url param
  const UrlCreator = window.URL || window.webkitURL
  var urlWithParams = new UrlCreator(url)
  Object.keys(data).forEach((k) => {
    urlWithParams.searchParams.append(k, data[k])
  })
  urlWithParams.searchParams.append(
    "v",
    ovl.getState().ovl.app.discCacheVersion.toString()
  )
  return urlWithParams.toString()
}
